export default __webpack_public_path__ + "static/media/FkLogo (2).839cdc4f.svg";